import { sSessionStorage } from "../localStorage.ts";
import { isSolvariId } from "./clientId.ts";

const sessionParam = "solvariSession";

// UUID-checked on read too: storage is shared with anything on the origin.
function getSolvariSessionId(): string | null {
  const value = sSessionStorage.getItem(sessionParam);
  return isSolvariId(value) ? value : null;
}

// UUID-checked on write: callers include cross-origin postMessage values →
// a non-uuid value is rejected before it reaches sessionStorage.
function storeSolvariSessionUuid(uuid: string): void {
  if (!isSolvariId(uuid)) {
    return;
  }
  sSessionStorage.setItem(sessionParam, uuid);
}

export { getSolvariSessionId, sessionParam, storeSolvariSessionUuid };
